<script>
import AddAuditor from "@/components/modules/ia/auditor/AddAuditor.vue";
import {mapActions, mapGetters} from "vuex";
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import AuditorMixin from "@/mixins/AuditorMixin";
import loading from "@/components/elements/AppLoading.vue";
import {AlertService} from "@/services/AlertService";

export default {
  name: "AuditorList",
  components: {loading, AddAuditor},
  mixins: [PaginationMixin, vueAppMixin, AuditorMixin],
  data() {
    return {
      filters: {
        page: 1,
        count: 30,
        query : '',
        status: 1,
        is_designated_person: null,
        category:'latest_audit.auditorable.audit_date_end.date-picker',
        order_position:'desc'
      },
      loading : false,
    }
  },
  methods: {
    ...mapActions(['deleteAuditor', 'getAuditorList','getSortedAuditorList']),
    truncateText(text, length) {
      if (text.length > length) {
        return text.substring(0, length) + '...';
      }
      return text;
    },
    async deleteSelected(auditorId) {
      if(await AlertService.confirmDeleteAlert('Delete Auditor', 'Are you sure you want to delete this Auditor?', 'Delete')){
        swal.fire({
          title:'ENTER YOUR PASSWORD',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off'
          },
          confirmButtonText:'PROCEED DELETION',
          cancelButtonText: 'CANCEL',
          showCancelButton:true,
          allowOutsideClick:false,
          allowEscapeKey:false,
          allowEnterKey:false,
          confirmButtonColor:'#dc3545',
          showLoaderOnConfirm:true,
          preConfirm:async (inputValue)=> {
            let response = await this.deleteAuditor({auditor_id: auditorId, password: inputValue});
            if (typeof response === 'boolean' && response) {
              return response;
            } else {
              if (response.hasOwnProperty('message') && !response.hasOwnProperty('errors')) {
                swal.showValidationMessage(response.message);
              }
              else{
                swal.showValidationMessage(response.errors.password.join(','));
              }
            }
          }
        })
          .then(async (result)=>{
            if(result.isConfirmed){
              await this.successAlert('AUDITOR DELETED SUCCESSFULLY','DELETE AUDITOR');
              await this.filterAuditorList();
            }
          });
      }

    },
    async showAuditor (auditorId) {
      await this.$router.push(
        {
          name: 'AuditorGeneralInfo',
          params: {
            id: auditorId,
          },
        },

      ).catch(() => {})
    },
    async showAuditorDesignatedPersonCertificateInfo (auditorId, isDP) {
      await this.$router.push(
        {
          name: 'AuditorDesignatedPersonCertificateInfo',
          params: {
            id: auditorId,
            isDP: isDP
          },
        },

      ).catch(() => {})
    },
    async showAuditorNewTab (auditorId) {
      const route= this.$router.resolve(
        {
          name: 'AuditorGeneralInfo',
          params: {
            id: auditorId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
    async setPage(page) {
      this.pagination.currentPage = page;
      this.filters.page = page
      await this.filterAuditorList();
    },
    async filterAuditorList() {
      this.loading = true;
      await this.getSortedAuditorList(this.filters);
      // await this.getAuditorList(this.filters);
      this.loading = false;
    },
    sortCategory(column){
      this.filters.category = column;
      this.filters.order_position = this.filters.order_position === 'desc' ? 'asc' : 'desc';
    }
  },
  async created() {
    this.getNewAuditorsList = _.debounce(this.filterAuditorList, 500);
    await this.filterAuditorList();
  },
  watch: {
    async 'filters.count'(count) {
      this.filters.count = count
      this.filters.page = 1
      await this.filterAuditorList();
    },
    async 'filters.status'(status) {
      this.filters.status = status;
      this.filters.page = 1;
      await this.filterAuditorList();
    },
    async 'filters.is_designated_person'(is_designated_person) {
      this.filters.is_designated_person = is_designated_person;
      this.filters.page = 1;
      await this.filterAuditorList();
    },
    async 'filters.query'(query) {
      this.filters.query = query;
      this.filters.page = 1;
      await this.getNewAuditorsList();
    },
    async 'filters.category'(category){
      this.filters.category = category;
      this.filters.page = 1;
      await this.filterAuditorList();
    },
    async 'filters.order_position'(position){
      this.filters.order_position = position;
      this.filters.page = 1;
      await this.filterAuditorList();
    }
  },
  computed : {
    ...mapGetters([
      'auditorList'
    ]),
    // filteredAuditorList() {
    //   if (!this.filters.query) {
    //     return this.auditorList;
    //   }
    //
    //   const query = this.filters.query.toLowerCase();
    //
    //   return this.auditorList.filter(auditor => {
    //     if (auditor.name?.toLowerCase().includes(query)) {
    //       return true;
    //     }
    //
    //     if (auditor.management_office?.name.toLowerCase().includes(query)) {
    //       return true;
    //     }
    //
    //     if (auditor.department?.name.toLowerCase().includes(query)) {
    //       return true;
    //     }
    //
    //     if (auditor.position?.name.toLowerCase().includes(query)) {
    //       return true;
    //     }
    //
    //     if ('audit'.toLowerCase().includes(query)) {
    //       return true;
    //     }
    //
    //     if (auditor.latest_audit?.auditorable?.port?.name.toLowerCase().includes(query)) {
    //       return true;
    //     }
    //
    //     if (auditor.latest_audit?.auditorable?.country?.name.toLowerCase().includes(query)) {
    //       return true;
    //     }
    //
    //     if (auditor.latest_audit?.auditorable?.audit_date_end?.human?.toLowerCase().includes(query)) {
    //       return true;
    //     }
    //
    //     if (auditor.certificates?.some(cert => {
    //       const fileNameMatch = cert.file_name?.toLowerCase().includes(query);
    //       const dateMatch = cert.expiration_date?.toLowerCase().includes(query);
    //       return fileNameMatch || dateMatch;
    //     })) {
    //       return true;
    //     }
    //
    //     return false;
    //   });
    // }
  }
}
</script>

<template>
  <div class="container-fluid px-4">
    <div class="row">
      <div class="col-12 pl-0">
        <div>
          <div class="row no-gutters justify-content-between mb-1">
            <div class="col-sm-auto flex-grow-0">
              <h3 class="mb-0 text-left">List of Auditors</h3>
            </div>
            <div class="col-sm-auto" v-if="isAllowed('audit-team.auditors.create')">
              <button class="e-btn e-btn-green force-white-all" data-toggle="modal" data-target="#AddNewAuditorModal">
                <font-awesome-icon icon="plus-square" style="width: 25px"/>
                <small class="font-weight-bold px-2">
                  NEW AUDITOR
                </small>
              </button>
            </div>
          </div>
          <div class="row no-gutters align-items-center justify-content-between">
            <div class="col-sm-auto pb-2 mr-2">
              <nav aria-label="...">
                <ul class="pagination text-smallest mb-0 pb-0">
                  <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                    <button class="page-link" @click="setPage(1)">First</button>
                  </li>

                  <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                    <button class="page-link" @click="setPage(page)">{{ page }}</button>
                  </li>

                  <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                    <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="col-5 pb-2">
              <div class="d-flex align-items-end justify-content-end filter-container">
                <div class="filter-item search-item">
                  <label class="filter-label">&nbsp;</label>
                  <form id="search-form" @submit.prevent>
                    <input
                      type="text"
                      id="auditorSearch"
                      class="form-control form-control-sm"
                      v-model="filters.query"
                      placeholder="Search Auditor"
                    >
                  </form>
                </div>
                <div class="filter-item">
                  <label class="filter-label">Status</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="filters.status"
                  >
<!--                    <option :value="null">All</option>-->
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
                <div class="filter-item">
                  <label class="filter-label">Person Type</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="filters.is_designated_person"
                  >
                    <option :value="null">All</option>
                    <option value="1">Designated Person</option>
                    <option value="0">Not Designated Person</option>
                  </select>
                </div>
                <div class="filter-item show-item">
                  <label class="filter-label">Show</label>
                  <select
                    id="rowCount"
                    class="form-control form-control-sm"
                    v-model="filters.count"
                  >
                    <option value="30">30 Rows</option>
                    <option value="50">50 Rows</option>
                    <option value="100">100 Rows</option>
                    <option value="10000">All Rows</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row no-gutters justify-content-between mb-1">
            <div class="col-sm-12">
              <div v-if="loading">
                <loading></loading>
              </div>
              <table v-else class="small e-tbl text-center">
                <thead class="bg-white sticky-header">
                <tr>
                  <th rowspan="2">#</th>
                  <th rowspan="2">NAME</th>
                  <th rowspan="2">MANAGEMENT OFFICE</th>
                  <th rowspan="2">DEPARTMENT</th>

                  <th
                    v-if="filters.is_designated_person == 1"
                    rowspan="2"
                  >
                    DESIGNATED PERSON CERTIFICATE
                  </th>

                  <th colspan="4">
                    LAST AUDIT
                  </th>

                  <th rowspan="2" style="width:350px">
                    CERTIFICATE EXPIRY
                  </th>

                  <th rowspan="2">
                    STATUS
                  </th>

                  <th rowspan="2">
                    ACTION
                  </th>
                </tr>

                <tr>
                  <th>TYPE</th>
                  <th>PORT / OFFICE ADDRESS</th>
                  <th>COUNTRY</th>
                  <th @click="sortCategory('latest_audit.auditorable.audit_date_end.date-picker')">
                    <div class="white-space-no-wrap">
                      DATE
                      <span class="h6 ml-2">
        <font-awesome-icon
          icon="arrow-up"
          v-if="filters.order_position === 'asc' && filters.category === 'latest_audit.auditorable.audit_date_end.date-picker'"
        />
        <font-awesome-icon
          icon="arrow-down"
          v-else-if="filters.order_position === 'desc' && filters.category === 'latest_audit.auditorable.audit_date_end.date-picker'"
        />
        <font-awesome-icon
          icon="sort"
          v-else
        />
      </span>
                    </div>
                  </th>
                </tr>
                </thead>
                <tbody>
                <template v-if="auditorList.length > 0">
                  <tr v-for="(auditor, index) in auditorList" :key="auditor.id" class="ia-auditor-list no-select" @dblclick="showAuditor(auditor.id)">
                    <td>{{ pagination.from + index}}</td>
                    <td>{{ auditor?.name?.toUpperCase() }}</td>
                    <td>{{ auditor?.management_office?.name.toUpperCase() }}</td>
                    <td>{{ auditor?.department?.name.toUpperCase() }}</td>
<!--                    <td>{{ auditor?.position?.name.toUpperCase() }}</td>-->
                    <td v-if="filters.is_designated_person == 1">
                      <font-awesome-icon
                        v-if="auditor?.certificates?.some(certificate => certificate.is_designated_person_certificate === 1)"
                        icon="file-pdf"
                        size="3x"
                        class="force-danger-all"
                        style="cursor: pointer"
                        @click="showAuditorDesignatedPersonCertificateInfo(auditor.id, true)"
                      />

                      <font-awesome-icon
                        v-else
                        icon="file-pdf"
                        size="3x"
                        style="cursor: default"
                      />
                    </td>
                    <td>Audit</td>
                    <td>{{ auditor?.latest_audit?.auditorable?.port?.name }}</td>
                    <td>{{ auditor?.latest_audit?.auditorable?.country?.name }}</td>
                    <td>{{ auditor?.latest_audit?.auditorable?.audit_date_end?.human }}</td>
                    <td>
                      <div
                        v-for="certificate in auditor?.certificates?.filter(
                          cert => cert.is_designated_person_certificate === 0
                        )"
                        :key="certificate.id">
                          <div v-if="certificate.expiration_date">
                          <span :title="certificate.file_name">
                            {{ truncateText(certificate.file_name, 25) }}
                          </span>
                          (<span class="date-highlight">{{ certificate.expiration_date }}</span>)
                        </div>
                      </div>
                    </td>
                    <td
                      :class="{
                    'td-status-active': auditor?.is_active === 1,
                    'td-status-inactive': auditor?.is_active === 0
                  }"
                    >
                      <span class="text-white">
                        {{ auditor?.is_active === 1 ? 'ACTIVE' : 'INACTIVE' }}
                      </span>
                    </td>
                    <td>
                      <div class="dropdown dropright my-1">
                        <button
                          id="actionDropdown"
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-sm btn-secondary force-white-all"
                          data-toggle="dropdown"
                        >
                          <font-awesome-icon icon="cogs"/>
                        </button>
                        <div aria-labelledby="actionDropdown" class="dropdown-menu py-0">
                          <button class="dropdown-item text-secondary font-weight-bolder"
                                  @click="showAuditor(auditor.id)"
                                  v-if="isAllowed('audit-team.auditors.view')"
                          >
                            <font-awesome-icon icon="eye"/>
                            View
                          </button>
                          <button class="dropdown-item text-secondary font-weight-bolder"
                                  @click="showAuditorNewTab(auditor.id)"
                                  v-if="isAllowed('audit-team.auditors.view')"
                          >
                            <font-awesome-icon icon="share"/>
                            View on New Tab
                          </button>
                          <button class="dropdown-item text-secondary font-weight-bolder text-danger"
                                  @click="deleteSelected(auditor.id)"
                                  v-if="isAllowed('audit-team.auditors.delete')"
                          >
                            <font-awesome-icon icon="trash" class="force-danger-all"/>
                            Delete
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="12" class="text-center font-weight-bold p-4">
                      No data found
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
          <AddAuditor
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.e-tbl {
  width: 100%;
  table-layout: auto;
}
.e-tbl thead tr th {
  border: 1px solid #b1b1b1;
}

.date-highlight {
  font-weight: bold;
  color: #007bff;
}
.td-status-active {
  background-color: #3abd82;
}

.td-status-inactive {
  background-color: #6b757d;
}
.filter-container {
  gap: 8px;
}

.filter-container input {
  width: 150px;
}

.filter-container select {
  width: auto;
  min-width: 130px;
}

#rowCount {
  min-width: 70px;
}
</style>
